import Component from './OffersSlider';

export default Component;
